<template>
    <v-container
        fluid
        fill-height
    >
        <v-row
            align="center"
            justify="center"
        >
            <v-col xs="12" sm="6" md="4">
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Вход в личный кабинет</v-toolbar-title>
                    </v-toolbar>
                    <v-form @submit.prevent="$emit('submit')">
                        <v-card-text>
                            <v-text-field
                                :value="credentials.email"
                                @input="$emit('update:email', $event)"
                                :error-messages="errors.email"
                                prepend-icon="mdi-email"
                                name="email"
                                label="Почта"
                                mask="email"
                                type="text">
                            </v-text-field>
                            <v-text-field
                                :value="credentials.password"
                                @input="$emit('update:password', $event)"
                                :error-messages="errors.password"
                                prepend-icon="mdi-lock"
                                name="password"
                                label="Пароль"
                                type="password"
                            ></v-text-field>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    :disabled="wait"
                                    :class="[{'js-sign-in-wait': wait}]"
                                    type="submit"
                                    color="primary"
                                >Войти</v-btn>
                            </v-card-actions>
                        </v-card-text>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'SignInDefault',
    props: {
        credentials: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
        wait: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
